import type {ComponentType} from 'react';

import {
    AccountBalanceIcon,
    AutoStoriesIcon,
    BoltIcon,
    CandleIcon,
    CastleIcon,
    CelebrationIcon,
    DirectionsWalkIcon,
    ExploreIcon,
    ExtensionIcon,
    FamilyRestroomIcon,
    FavoriteIcon,
    FootprintIcon,
    ForestIcon,
    GroupsIcon,
    HeadphonesIcon,
    HikingIcon,
    HistoryIcon,
    LocationOnIcon,
    MapIcon,
    MuseumIcon,
    PaletteIcon,
    RouteIcon,
    SchoolIcon,
    StarIcon,
    TrendingUpIcon,
    WaterDropIcon,
    WineBarIcon,
    WorkspacePremiumIcon
} from 'Images/icons';

/** Map of predefined icon names (from Category.predefinedIcon) to their React components. */

export const CATEGORY_ICON_MAP: Record<string, ComponentType<any>> = {
    AccountBalanceIcon,
    AutoStoriesIcon,
    BoltIcon,
    CandleIcon,
    CastleIcon,
    CelebrationIcon,
    DirectionsWalkIcon,
    ExploreIcon,
    ExtensionIcon,
    FamilyRestroomIcon,
    FavoriteIcon,
    FootprintIcon,
    ForestIcon,
    GroupsIcon,
    HeadphonesIcon,
    HikingIcon,
    HistoryIcon,
    LocationOnIcon,
    MapIcon,
    MuseumIcon,
    PaletteIcon,
    RouteIcon,
    SchoolIcon,
    StarIcon,
    TrendingUpIcon,
    WaterDropIcon,
    WineBarIcon,
    WorkspacePremiumIcon
};